import { Navigate, Route, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BankIDRedirect from '~/components/authentication/bankid/bankid-redirect.js';
import { CloseContext } from '~/hooks/use-close-context.js';
import QuickDepositMobile from '~/components/payment/quick-deposit-beta';
import {
	ROUTE_BANKID,
	ROUTE_MOBILE_QUICK_DEPOSIT,
	ROUTE_SHOP_DETAIL,
	ROUTE_PROMOTIONS_DETAIL,
	ROUTE_FREE_TO_PLAY_DETAIL,
	ROUTE_LOGIN
} from '~/components/router/constants.js';
import { selectQuickDepositMobile } from '~/components/brand/ducks/selectors.js';
import { SIDEBAR, MODAL } from '~/ui/ui-constants.ts';
import SidebarRoutes from '../sidebar-paths.js';
import ContextAwareRoutes from '~/components/router/context-aware-routes';
import ProtectedRoute from '~/components/router/protected-route';
import MarketplaceItemDetail from '~/components/marketplace/marketplace-async.js';
import FreeToPlayItemDetail from '~/components/free-to-play/free-to-play-item-detail';
import useContextualPathTransformer from '~/hooks/use-contextual-path-transformer.js';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';

const SidebarRedirect = () => {
	const params = new URLSearchParams(window.location.search);

	params.delete(SIDEBAR);
	params.append(SIDEBAR, params.get(MODAL));
	params.delete(MODAL);

	const [, , ...pathSegments] = window.location.pathname.split('/');

	return (
		<Navigate
			to={{
				pathname: ['', ...pathSegments].join('/'),
				search: params.toString()
			}}
		/>
	);
};

const RoutesModal = () => {
	const isQuickDepositMobile = useSelector(selectQuickDepositMobile);
	const location = useLocation();
	const transformPath = useContextualPathTransformer();
	const authenticated = useSelector(authenticationSelector);
	const loginURL = transformPath(ROUTE_LOGIN);

	return (
		<ContextAwareRoutes>
			<Route path={ROUTE_BANKID} element={<BankIDRedirect />} />
			{SidebarRoutes.map(path => (
				<Route key={path} path={path} element={<SidebarRedirect />} />
			))}
			{isQuickDepositMobile && (
				<Route
					path={`/${ROUTE_MOBILE_QUICK_DEPOSIT}`}
					element={<QuickDepositMobile fullLocation={location} />}
				/>
			)}
			<Route
				path={`${ROUTE_SHOP_DETAIL}/:type/:id`}
				element={
					<ProtectedRoute>
						<MarketplaceItemDetail />
					</ProtectedRoute>
				}
			/>
			<Route
				path={`${ROUTE_SHOP_DETAIL}/:type/:id/:subId`}
				element={
					<ProtectedRoute>
						<MarketplaceItemDetail />
					</ProtectedRoute>
				}
			/>
			<Route
				path={`${ROUTE_PROMOTIONS_DETAIL}/:type/:id`}
				element={
					<ProtectedRoute>
						<MarketplaceItemDetail />
					</ProtectedRoute>
				}
			/>
			<Route
				path={authenticated ? `${ROUTE_FREE_TO_PLAY_DETAIL}/:type/:id` : loginURL}
				element={<FreeToPlayItemDetail />}
			/>
			<Route path="*" element={<CloseContext />} />
		</ContextAwareRoutes>
	);
};

export default RoutesModal;
